import { dateToMYDObject } from "../../handlers/utilityFunctions";

interface PersonalInfoProfile {
	gender?: string;
	maritalStatus?: string;
	dateOfBirth?: string;
}

interface PersonalInfoRequest {
	dateOfBirth: ReturnType<typeof dateToMYDObject>;
	gender?: string;
	maritalStatus?: string;
}

export class PersonalInfo {
	gender?: string;
	maritalStatus?: string;
	date: ReturnType<typeof dateToMYDObject>;

	constructor(profile: PersonalInfoProfile) {
		this.gender = profile.gender;
		this.maritalStatus = profile.maritalStatus;
		this.date = dateToMYDObject(profile.dateOfBirth);
	}

	/**
	 * An unanswered question is left out of the request rather than sent as "".
	 * The server marks both fields optional but validates them against an enum,
	 * and `@IsOptional()` only waives that for a missing value — an empty string
	 * still reaches `@IsEnum` and fails the whole save.
	 */
	getPersonalInfoRequest(): PersonalInfoRequest {
		const request: PersonalInfoRequest = { dateOfBirth: this.date };

		if (this.gender) request.gender = this.gender;
		if (this.maritalStatus) request.maritalStatus = this.maritalStatus;

		return request;
	}
}
